const findGlobalFontSize = (defaultValue = 10) => {
    const html = document.querySelector('html');
    const styles = window.getComputedStyle(html);
    const fontSize = styles && styles.getPropertyValue('font-size');
    if (fontSize && fontSize.endsWith('px')) {
        return fontSize.replace('px', '');
    }
    return defaultValue;
};

export { findGlobalFontSize };
